<template>
  <div id="updatebitrixpackagepermission"  class="animated fadeIn">
  
  </div>
</template>
<script>
export default {
  name: 'updatebitrixpackagepermission',
  props: ['eligibilitydata'],
  data () {
    return {
      salesPerson: '',
      haaId: '',
      partnername: '',
      defaultpackage: []
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.partnername = localStorage.getItem('CompanyName')
    // setTimeout(() => {
    //   var maketplace = document.querySelector('#dropMarkedsplads')
    //   maketplace.addEventListener('click', function () {
    //     window.location.replace('#/markedsplads')
    //   })
    // }, 500)
  },
  mounted () {
    this.getInitialPackageValue()
  },
  methods: {
    wait1hourreminder () {
      const timenow = new Date()
      const timeafter1hour = new Date()
      timeafter1hour.setTime(timenow.getTime() + 1 * 60 * 60 * 1000)
      localStorage.setItem('timeaddedcard', timenow)
      localStorage.setItem('timeaddedcardexpiry', timeafter1hour)
      this.$emit('Nopaymentmethod', 'false')
    },
    check1hour () {
      const timeaccessnow = new Date()
      var togettime = localStorage.getItem('timeaddedcard')
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry')
      const togettimenew = new Date(togettime)
      const togettimeexpirynew = new Date(togettimeexpiry)
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    getInitialPackageValue () {
      this.defaultpackage[0] = 'ClimatePartner'
      this.defaultpackage[1] = 'FBPostRecommendation'
      this.defaultpackage[2] = 'PartnerAccountingInteg'
      this.defaultpackage[3] = 'ExtraReservation'
      this.defaultpackage[4] = 'ExternalProWebsite'
      this.defaultpackage[5] = 'OfferCreator'
      this.defaultpackage[6] = 'PartnerloginMesterMesterReserve'
      this.defaultpackage[7] = 'PartnerLoginUdbudJobs'
      this.defaultpackage[8] = 'PartnerLoginMarketplaceReserve'
      this.defaultpackage[9] = 'PartnerloginMesterMesterPost'
      this.defaultpackage[10] = 'PartnerLoginMarketplaceViewer'
      this.defaultpackage[11] = 'PersonalPartnerLogin'
      this.defaultpackage[12] = 'AccessVideoProProfile'
      this.defaultpackage[13] = 'AccessDescriptionText'
      this.defaultpackage.forEach(elementfeature => {
        localStorage.setItem(elementfeature, false)
      })
      this.getpackage()
    },
    getpackage () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      // https://bitrixapimaster.haandvaerker.dk/v1/
      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var boughtfeature = []
            // var packagedataaddon = res.data.PACKAGE_ADDONS
            var packagedatafeature = res.data.PACKAGE_FEATURES
            var packagedatafeatureeach = res.data.ACTIVE

            if (packagedatafeatureeach && packagedatafeature) {
              packagedatafeature.forEach(element => {
                boughtfeature.push(element.SHORT_CODE + '-' + element.LIMITATION)
              })
              boughtfeature.forEach((elements) => {
                var elementsname = elements.split('-')[0]
                var elementslimitations = elements.split('-')[1]
                if (this.defaultpackage.includes(elementsname)) {
                  if (elementslimitations !== null && elementslimitations !== 'null') {
                    localStorage.setItem(elementsname, true)
                    localStorage.setItem(elementsname + 'limit', elementslimitations)
                  } else {
                    localStorage.setItem(elementsname, true)
                  }
                  if (localStorage.getItem('PartnerLoginMarketplaceReserve') || localStorage.getItem('PartnerloginMesterMesterReserve')) {
                    localStorage.setItem('PartnerLoginMarketplaceViewer', true)
                  }
                }
              })
            }
            localStorage.setItem('PartnerloginMesterMesterReserve-nummode', res.data.nummode)
            localStorage.setItem('PartnerloginMesterMesterReserve-size', res.data.reserve_size)
            localStorage.setItem('PartnerLoginMarketplaceReserve-nummode', res.data.nummode)
            localStorage.setItem('PartnerLoginMarketplaceReserve-size', res.data.reserve_size)
            localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE)
            if (localStorage.getItem('PartnerLoginUdbudJobs')) {
              setTimeout(() => {
                document.getElementById('offentlige-udbud').classList.remove('hide')
              }, 500)
            }
            if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
              setTimeout(() => {
                document.getElementById('offentlige-udbud').classList.add('hide')
              }, 500)
              // setTimeout(() => {
              //   document.getElementById('privat-udbud').classList.add('hide')
              // }, 500)
            }
            // console.log('boughtfeature', boughtfeature)
            // console.log('localhoststore', localStorage)
            console.log('this.$bitrixapi', this.$bitrixapi)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// updatebitrixpackagepermission.vue?7d266c4d